(function () {
  function getNumberAttr(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10);
    return Number.isFinite(v) ? v : fallback;
  }

  // Hash simplu, stabil
  function hashString(str) {
    var h = 2166136261; // FNV-ish
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0);
  }

  function pickInRange(seedStr, min, max) {
    if (max <= min) return min;
    var range = (max - min + 1);
    var h = hashString(seedStr);
    return min + (h % range);
  }

  function renderSocialProof() {
    document.querySelectorAll(".sl-social-proof").forEach(function (el) {
      var productId = el.getAttribute("data-product-id") || "";
      if (!productId) return;

      var minPeople = getNumberAttr(el, "data-min-people", 2);
      var maxPeople = getNumberAttr(el, "data-max-people", 9);
      var minMinutes = getNumberAttr(el, "data-min-minutes", 3);
      var maxMinutes = getNumberAttr(el, "data-max-minutes", 28);
      var ttlMinutes = getNumberAttr(el, "data-ttl-minutes", 10);

      // "Time bucket" => se schimbă la fiecare ttlMinutes
      var bucket = Math.floor(Date.now() / (ttlMinutes * 60 * 1000));

      var people = pickInRange(productId + "|p|" + bucket, minPeople, maxPeople);
      var minutes = pickInRange(productId + "|m|" + bucket, minMinutes, maxMinutes);

      var textEl = el.querySelector(".sl-social-proof__text");
      if (!textEl) return;

      textEl.innerHTML =
  `<strong>${people}</strong> persoane au comandat în ultimele <strong>${minutes}</strong> minute`;

    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderSocialProof);
  } else {
    renderSocialProof();
  }

  document.addEventListener("shopify:section:load", renderSocialProof);
})();
